import axios from "axios";

export function cjxzfw(params) {
  return axios({
    url: "/api/cjxzfw",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: params,
  });
}

export function getBdzdByFwid(params) {
  return axios({
    url: "/api/getBdzdByFwid",
    method: "post",
    data: params,
  });
}

export function getJsonByFwid(params) {
  return axios({
    url: "/api/getJsonByFwid",
    method: "post",
    data: params,
  });
}
export function getjbxx(params) {
  return axios({
    url: "/api/getjbxx",
    method: "post",
    data: params,
  });
}
export function sendMsg(params) {
  return axios({
    url: "/api/sendMsg",
    method: "post",
    data: params,
  });
}
export function savesqd(params) {
  return axios({
    url: "/api/savesqd",
    method: "post",
    data: params,
  });
}
export function getSysName(params) {
  return axios({
    url: "/api/getSysName",
    method: "post",
    data: params,
  });
}
export function getFwfjInfo(params) {
  return axios({
    url: "/api/rcsw/getFwfjInfo",
    method: "post",
    data: params,
  });
}

export function getfwlxinfo(params) {
  return axios({
    url: "/api/getfwlxinfo",
    method: "post",
    data: params,
  });
}

export function getfwinfo(params) {
  return axios({
    url: "/api/getfwinfo",
    method: "post",
    data: params,
  });
}

//============================================
export function removefile(params) {
  return axios({
    url: "/api/removefile",
    method: "post",
    data: params,
  });
}
export function checkSpr(params) {
  return axios({
    url: "/api/checkSpr",
    method: "post",
    data: params,
  });
}
export function FromDIY(params) {
  return axios({
    url: "/api/FromDIY",
    method: "post",
    data: params,
  });
}
export function getBdzdb(params) {
  return axios({
    url: "/api/rcsw/getBdzdb",
    method: "post",
    data: params,
  });
}
export function selectSpr(params) {
  return axios({
    url: "/api/selectSpr",
    method: "post",
    data: params,
  });
}
export function getwdfwinfo(params) {
  return axios({
    url: "/api/getwdfwinfo",
    method: "post",
    data: params,
  });
}
export function scFwid(params) {
  return axios({
    url: "/api/scFwid",
    method: "post",
    data: params,
  });
}
export function getBdzdlxInfo(params) {
  return axios({
    url: "/api/getBdzdlxInfo",
    method: "post",
    data: params,
  });
}
export function submitFwToApprove(params) {
  return axios({
    url: "/api/submitFwToApprove",
    method: "post",
    data: params,
  });
}
export function selectFwlx(params) {
  return axios({
    url: "/api/selectFwlx",
    method: "post",
    data: params,
  });
}
export function selectfwfj(params) {
  return axios({
    url: "/api/selectfwfj",
    method: "post",
    data: params,
  });
}
export function savecjfw(params) {
  return axios({
    url: "/api/savecjfw",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: params,
  });
}
export function savedybd(params) {
  return axios({
    url: "/api/savedybd",
    method: "post",
    data: params,
  });
}
export function delWdfw(params) {
  return axios({
    url: "/api/delWdfw",
    method: "post",
    data: params,
  });
}

// =========================================================================
export function getBhyy(params) {
  return axios({
    url: "/api/rcsw/getBhyy",
    method: "post",
    data: params,
  });
}

export function addInfo(params) {
  return axios({
    url: "/api/rcsw/addInfo",
    method: "post",
    data: params,
  });
}

export function xzsm(params) {
  return axios({
    url: "/api/rcsw/xzsm",
    method: "post",
    data: params,
  });
}

export function getTdr(params) {
  return axios({
    url: "/api/rcsw/getTdr",
    method: "post",
    data: params,
  });
}

export function delInfo(params) {
  return axios({
    url: "/api/rcsw/delInfo",
    method: "post",
    data: params,
  });
}

export function getByYhbh(params) {
  return axios({
    url: "/api/rcsw/getByYhbh",
    method: "post",
    data: params,
  });
}

export function searchTableInfo(params) {
  return axios({
    url: "/api/rcsw/searchTableInfo",
    method: "post",
    data: params,
  });
}

export function updateMyDzStatus(params) {
  return axios({
    url: "/api/rcsw/updateMyDzStatus",
    method: "post",
    data: params,
  });
}

export function setSprInfo(params) {
  return axios({
    url: "/api/rcsw/setSprInfo",
    method: "post",
    data: params,
  });
}

export function sendMessage(params) {
  return axios({
    url: "/api/rcsw/sendMessage",
    method: "post",
    data: params,
  });
}
